export default "__VITE_ASSET__DVlSRGlo__"